export default __webpack_public_path__ + "static/media/kshps.54edb476.png";